import { render, staticRenderFns } from "./DebtActionBalances.vue?vue&type=template&id=66b3b6d4&"
import script from "./DebtActionBalances.vue?vue&type=script&lang=js&"
export * from "./DebtActionBalances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports